// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__w8yDy","formControl":"addForm_formControl__n4Gol","list":"addForm_list__86XOK","btnWrpper":"addForm_btnWrpper__O5dnS"};